import { colors } from '@novozymes-digital/components';

export const frontiaColors = {
  ...colors,
  grayBlue: '#92A2A6',
};
